<template>
    <div style="overflow: hidden;width: 100%">
        <div class="handle">
            <div class="container">
                <a-row>
                    <a-col :span="24">
                        <a class="logo" href="">
                            <img src="../img/logo2.png">
                            <!--<p>广东省环境监测中心阳光快采平台</p>-->
                        </a>
                        <div class="right size5">
                            <a-tooltip placement="bottom" >
                                <div slot="title">
                                    <span>首页</span>
                                </div>
                                <a class="color-ash" href="" style="cursor: pointer;">
                                    <a-icon type="home"  />
                                </a>
                            </a-tooltip>
                            <a-tooltip placement="bottom" @click="onHelp">
                                <div slot="title" >
                                    <span>帮助</span>
                                </div>
                                <a class="color-ash" style="cursor: pointer;" data-step="1" data-intro="<img src='/supplier/img/bz.gif'/><div><b>帮助中心</b><p>点击此处进入帮助中心，查看操作教程！</p></div>">
                                    <a-icon type="question-circle"/>
                                </a>
                            </a-tooltip>
                            <a-tooltip placement="bottom">
                                <div slot="title">
                                    <span>退出登录</span>
                                </div>
                                <a class="color-ash" href="javascript:;" @click="handleLogout" style="cursor: pointer;">
                                    <a-icon type="poweroff" />
                                </a>
                            </a-tooltip>
                            <span class="size2 color-ash ml-5 mr-2 pl-5 border-left" style="cursor: pointer;" @click="onPerson">{{userName}}</span>
                            <a-avatar icon="user" @click="onPerson" />
                        </div>
                    </a-col>
                </a-row>
            </div>
        </div>
        <div style="height: 56px;"></div>
        <div class="i-my-info">
            <img class="index-bg" src="../img/bg.png">
            <div class="container">
                <a-row>
                    <a-col class="mt-6" :span="24">
                        <IndexMenu ref="indexMenu"  @openProjectDetails="openProjectDetails" />
                    </a-col>
                </a-row>
                <a-row class="mt-6 main-nav">
                    <a-col :span="8">
                        <a class="active" @click="toIndex()">
                            <div>
                                <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#icon-project-a"></use>
                                </svg>
                                <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#icon-project"></use>
                                </svg>
                            </div>
                            <div>
                                <b class="size6">我的项目</b>
                            </div>
                        </a>
                    </a-col>
                    <a-col :span="8">
                        <a @click="toAnnounceIndex" data-step="2" data-intro="<img src='/supplier/img/xmgg.gif'/><div><b>项目公告</b><p>点击此处查看所有的项目公告，可以进行项目报名！</p></div>">
                            <div>
                                <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#icon-notice-a"></use>
                                </svg>
                                <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#icon-notice"></use>
                                </svg>
                            </div>
                            <div>
                                <b class="size6">项目公告</b>
                            </div>
                        </a>
                    </a-col>
                    <a-col :span="8">
                        <a @click="toAccount" data-step="3" data-intro="<img src='/supplier/img/zhgl.gif'/><div><b>账号管理</b><p>点击此处可以管理个人帐号、进行单位认证、维护单位信息！</p></div>">
                            <div>
                                <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#icon-my-a"></use>
                                </svg>
                                <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#icon-my"></use>
                                </svg>
                            </div>
                            <div>
                                <b class="size6">账号管理</b>
                            </div>
                        </a>
                    </a-col>
                </a-row>
            </div>
        </div>
        <div class="container" style="min-height: calc(100vh - 56px - 225px - 88px);">
            <a-row>
                <a-col class="mt-6" :span="24">
                    <a-card>
                        <a-tabs  v-model="activeKey" >

                            <a-tab-pane tab="今天开标项目" key="1" v-if="todayData.length !== 0">
                                <a-list item-layout="horizontal" :pagination="pagination" :data-source="todayData">
                                    <a-list-item slot="renderItem" key="item.id" slot-scope="item, index">
                                        <div >
                                            <p class="color-black size5 mb-0"> <B><span style="color:#ff9a0f;cursor: pointer;"  >[{{item.extras.methodName}}]</span><a
                                                    href="javascript:;" style="color: rgba(0, 0, 0, 0.65);" @click="projectDetails(item)"> {{item.projectName }}</a></B></p>
                                            <p  class="mt-3 mb-0" style="font-weight: 500;color: #8c8c8c !important;">
                                            <span>
                                              <a-icon type="bank"/>
                                             采购单位:   {{item.purchaserUnit}}
                                            </span>
                                                <span class="ml-5">
                                              <a-icon type="clock-circle"/>
                                                发布时间 {{item.noticeTime}}
                                            </span>
                                            </p>
                                        </div>
                                        <br/>

                                        <div slot="actions" class="ml-6">
                                            <p class="color-black size3 mb-0"> 开标时间 {{item.openTime}}</p>
                                            <p class="size3 mb-0 mt-1" style="color:red;cursor: pointer;font-weight: bold;" v-if="item.method=='1'" @click="opneGuidelines(item.projectId)">竞价操作指引</p>
                                        </div>
                                        <div slot="actions" style="color: red;font-size: 20px;cursor: pointer;">
                                            <span>{{ item.extras.bidStatus }}</span>
                                        </div>
                                    </a-list-item>
                                </a-list>
                            </a-tab-pane>

                            <a-tab-pane tab="我的在办项目" key="2">
                                <a-list item-layout="horizontal" :pagination="pagination" :data-source="dealData">
                                    <a-list-item slot="renderItem" key="item.id" slot-scope="item, index">
                                        <div >
                                            <p class="color-black size5 mb-0"> <B><span style="color:#ff9a0f;cursor: pointer;"  >[{{item.extras.methodName}}]</span><a
                                                    href="javascript:;"  style="color: rgba(0, 0, 0, 0.65);"  @click="projectDetails(item)"> {{item.projectName }}</a></B></p>
                                            <p  class="mt-3 mb-0" style="font-weight: 500;color: #8c8c8c !important;">
                                            <span>
                                              <a-icon type="bank"/>
                                             采购单位:   {{item.purchaserUnit}}
                                            </span>
                                                <span class="ml-5">
                                              <a-icon type="clock-circle"/>
                                                发布时间 {{formatDate(item.noticeTime)}}
                                            </span>
                                            </p>
                                        </div>
                                        <br/>

                                        <div slot="actions" class="ml-6" v-if="item.systemType !=='4'">
                                            <p class="color-black size3 mb-0"> 开标时间 {{formatDate(item.openTime)}}</p>
                                            <p class="size3 mb-0 mt-1" style="color:red;cursor: pointer;font-weight: bold;" v-if="item.method=='1'" @click="opneGuidelines(item.projectId)">竞价操作指引</p>
                                        </div>
                                        <div slot="actions" class="ml-6" v-else>
                                            <p class="color-black size3 mb-0"> 截止时间 {{formatDate(item.signEnd)}}</p>
                                        </div>
                                        <div slot="actions" style="color: red;font-size: 20px;cursor: pointer;">
                                            <span>{{ item.extras.bidStatus }}</span>
                                        </div>
                                    </a-list-item>
                                </a-list>
                            </a-tab-pane>

                            <a-tab-pane tab="我的历史项目" key="3">
                                <a-list item-layout="horizontal"   :pagination="pagination" :data-source="historyData">
                                    <a-list-item slot="renderItem" key="item.id" slot-scope="item, index">
                                        <div >
                                            <p class="color-black size5 mb-0"> <B><span style="color:#ff9a0f;cursor: pointer;"  >[{{item.extras.methodName}}]</span><a
                                                    href="javascript:;"  style="color: rgba(0, 0, 0, 0.65);" @click="projectDetails(item)"> {{item.projectName }}</a></B></p>
                                            <p  class="mt-3 mb-0" style="font-weight: 500;color: #8c8c8c !important;">
                                            <span>
                                              <a-icon type="bank"/>
                                             采购单位:   {{item.purchaserUnit}}
                                            </span>
                                                <span class="ml-5">
                                              <a-icon type="clock-circle"/>
                                                发布时间 {{formatDate(item.noticeTime)}}
                                            </span>
                                            </p>
                                        </div>
                                        <br/>

                                        <div slot="actions" class="ml-6">
                                            <p class="color-black size3 mb-0"> 开标时间 {{formatDate(item.openTime)}}</p>
                                        </div>
                                        <div slot="actions" style="color: red;font-size: 20px;cursor: pointer;">
                                            <span>{{ item.extras.bidStatus }}</span>
                                        </div>
                                    </a-list-item>
                                </a-list>
                            </a-tab-pane>
                            <!--     ************************************************邀请函***************************************************************    -->
                            <a-tab-pane  key="4" v-if="inviteData.length !== 0">

                                <template slot="tab">
                                    <a-badge dot style="font-size: 20px;font-weight: bold">
                                      邀请函
                                    </a-badge>
                                </template>

                                <a-list itemLayout="horizontal"  :pagination="pagination" :data-source="inviteData">
                                    <a-list-item slot="renderItem" key="item.id" slot-scope="item, index">
                                        <a-list-item-meta>
                                            <a slot="title" href="javascript:;" @click="inviteDetails(item)">
                                                {{ item.projectName }}
                                                <span style="color:#ff9a0f">[邀请函]</span>
                                            </a>
                                        </a-list-item-meta>
                                        <div slot="actions" style="color: red;font-size: 20px;cursor: pointer;">
                                            {{item.inviteTime}}
                                        </div>
                                    </a-list-item>
                                </a-list>
                            </a-tab-pane>
                            <!-- ****************************************************联合体邀请*********************************************** -->
                            <a-tab-pane tab="联合报名邀请" key="5">
                                <template slot="tab">
                                    <a-badge dot style="font-size: 20px;font-weight: bold">
                                        联合报名邀请
                                    </a-badge>
                                </template>
                                <supplier-lht-invitation2  ref="lhtInvitationRef2" ></supplier-lht-invitation2>
                            </a-tab-pane>
                        </a-tabs>
                    </a-card>
                </a-col>
            </a-row>
            <div>
                <InviteDetails :visible="inviteVisible" ref="invite" @cancel="inviteCancel"></InviteDetails>
                <InviteLegalDetails :visible="inviteLegalVisible" ref="inviteLegal" @cancel="inviteLegalCancel"></InviteLegalDetails>
                <invite-demand-details :visible="inviteDemandVisible" ref="inviteDemand" @cancel="inviteDemandVisible = false"></invite-demand-details>

                <AccountTip :visible="accountVisible" ref="act" @cancel="actCancle"></AccountTip>
            </div>

<!--            <a-modal v-model="supplierTypeVisible" title="帐号提示" @ok="handleOk" :confirmLoading="confirmLoading"  :destroyOnClose="true">-->
<!--                <p style="font-size: 15px;padding-bottom: 20px;">感谢您注册志正快速采购平台，请选择你的供应商类型</p>-->
<!--                <div>-->
<!--                    <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" >-->
<!--                        <a-form-model-item  prop="supplierType">-->
<!--                            <a-radio-group v-model="ruleForm.supplierType">-->
<!--                                <a-radio value="2">-->
<!--                                    法人供应商-->
<!--                                </a-radio>-->
<!--                                <a-radio value="1">-->
<!--                                    个体户供应商-->
<!--                                </a-radio>-->
<!--                                <a-radio value="0">-->
<!--                                    个人供应商-->
<!--                                </a-radio>-->
<!--                            </a-radio-group>-->
<!--                        </a-form-model-item>-->
<!--                    </a-form-model>-->
<!--                </div>-->
<!--            </a-modal>-->

        </div>
        <CommonFooter />
        <BiddingGuidelines ref="biddingGuidelines"/>
    </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import qs from 'qs'
  import CommonHeader from './common/CommonHeader'
  import CommonFooter from './common/CommonFooter'
  import IndexMenu from './common/IndexMenu'
  import moment from "moment"
  import IntroJs from 'intro.js'
  import InviteDetails from './project/InviteDetails'
  import AccountTip from './project/AccountTip'
  import InviteLegalDetails from './project/InviteLegalDetails'
  import InviteDemandDetails from "./project/InviteDemandDetails";
  import SupplierLhtInvitation2 from "./common/SupplierLhtInvitation2";
  import BiddingGuidelines from './biddingGuidelines/BiddingGuidelines'


  // let supplierTypeValidator = (rule, value, callback) => {
  //     if (!value) {
  //         callback(new Error('请选择供应商类型'));
  //         return
  //     }
  //     callback()
  // }

  export default {
    components: {
      InviteLegalDetails,
      CommonHeader,
      CommonFooter,
      IndexMenu,
      moment,
      IntroJs,
      InviteDetails,
      AccountTip,
      InviteDemandDetails,
      SupplierLhtInvitation2,
      BiddingGuidelines
    },
    created() {
      this.userName = this.$store.getters.nickname
      this.todayProject()
      // this.showTip()
        // this.dealProject()
      // this.historyProject()
      this.invitedList()
    },
     watch: {
          activeKey(newValue, oldValue) {
              if(newValue !== oldValue) {
                  if (newValue === '1') {
                      this.todayProject()
                  }else if (newValue === '2'){
                      this.dealProject()
                  }else if (newValue === '3'){
                      this.historyProject()
                  }else if (newValue === '4'){
                      this.invitedList()
                  }else if (newValue === '5'){
                      this.$nextTick(()=>{
                          this.$refs.lhtInvitationRef2.onLoad()
                      })
                  }else {
                      this.todayProject()
                  }
              }
          }
     },
    mounted(){
        this.currentAccount = this.$ls.get('user').id
        if (!localStorage.hasOwnProperty(this.currentAccount)) {
            this.guide()
        }
    },
    data() {
      return {
        actions: [
          {type: 'bank', text: '广东省环境监测中心'},
          {type: 'clock-circle', text: '发布时间：今天10: 30 '},
        ],
        hideOnSinglePage: true,
        userName:'',
        guideValue:1,
        dealData: [],
        todayData: [],
        historyData: [],
        inviteData: [],
        random:this.$route.query.random,
        inviteVisible:false,
        inviteLegalVisible:false,
        inviteDemandVisible:false,
        accountVisible: false,
        defaultActiveKey: '1',
        currentAccount: '',
          spinning: false,
          pagination: {
          onChange: page => {
          },
          itemRender:(current, type, originalElement) => {
              if (type === 'prev') {
                  return <a>上一页</a>;
              } else if (type === 'next') {
                  return <a>下一页</a>;
              }
              return originalElement;
          },
          showTotal:(total) => {
              return `共${total}条`
          },
          showSizeChanger:true,
          defaultPageSize:10,
          size:'large'
        },
        activeKey: this.$route.query.activeKey?this.$route.query.activeKey:'1',
        confirmLoading:false,
      }
    },
    methods: {
      itemRender(current, type, originalElement) {
        if (type === 'prev') {
          return <a>上一页</a>;
        } else if (type === 'next') {
          return <a>下一页</a>;
        }
        return originalElement;
      },

      ...mapActions(['Logout']),
      ...mapGetters(['nickname', 'avatar']),
      handleLogout() {
        const that = this
        this.$confirm({
          title: '提示',
          content: '真的要注销登录吗 ?',
          onOk() {
            return that.Logout({}).then(() => {
            }).catch(err => {
              that.$message.error({
                title: '错误',
                description: err.message
              })
            })
          },
          onCancel() {
          }
        })
      },
        formatDate(value) {
            if (!value){
                return "未设置时间"
            }
            value = value.replace(new RegExp(/-/gm) ,"/")
            value = moment(new Date(value)).format("YYYY/MM/DD HH:mm")
            return value
        },
      onPerson() {
        this.$router.push({path:'/account/AccountManage'})
      },
        onLoadProjectSupplierNotice(item){
            let that = this
            this.$http.get('/api/v1/supplier/notice/getBidNoticeList.json?xmid='+item.projectId).then(function (res) {
                if (res.code === 200)
                {
                    const result = res.result
                    if (result && result.length>0) {
                            if (result.length === 1) {
                                that.$refs.indexMenu.onOpenSupplierView(result[0].id,item)
                            } else {
                                that.$refs.indexMenu.onSysSupplierMessage(item)
                            }
                    }else {
                        that.openProjectDetails(item)
                    }
                }
            });
        },
      guide() {
          let that = this
        IntroJs().setOptions({
          prevLabel: "上一步",
          nextLabel: "下一步",
          skipLabel: "跳过指引",
          doneLabel: "知道了，谢谢",
          exitOnOverlayClick: false,
          showBullets: false,
        }).oncomplete(function () {
          //点击跳过按钮后执行的事件
        }).onexit(function () {
            //点击结束按钮后， 执行的事件
            localStorage[that.currentAccount] = '1'
            if(that.guideValue === 1) {// 防止重复弹窗
                that.guideValue = 0
                that.guide2Auth()
            }
        }).start();

      },
      guide2Auth() {// 引导用去认证
          let that = this
          this.$http.get('/api/v1/supplier/account/isGuide2Auth').then(res => {
              console.log(res === true ? '需要引导去认证' : '不需要引导')
              if(res === true) {
                  that.accountVisible = true
              }
          })
      },
      initData() {
        this.$forceUpdate()
        this.todayProject()
        this.dealProject()
        this.historyProject()
      },
        projectDetails(item) {
          this.onLoadProjectSupplierNotice(item)
        },
        openProjectDetails(item)
        {
                if(item.systemType === '2'){
                    this.$router.push({path:'/compete/PacksList?id='+item.projectId});
                }else if (item.systemType === '1'){
                    this.$router.push({path:'/legal/PacksList?id='+item.projectId})
                }else if (item.systemType === '4')
                {
                    this.$router.push({path:'/demand/DemandList?id='+item.projectId})
                }

        },
      dealProject() {
        this.$http.get('/api/v1/supplier/project/toBeDealtList.json').then(res => {
          this.dealData = res.result // return res
        })
      },
      todayProject() {
        this.$http.get('/api/v1/supplier/project/todayList.json').then(res => {
          this.todayData = res.result
            if (this.todayData && this.todayData.length === 0){

                if (this.activeKey!=='4')
                {
                    this.activeKey = '2'
                }

            }
        })
      },
      historyProject() {
        this.$http.get('/api/v1/supplier/project/historyList.json').then(res => {
          this.historyData = res.result // return res
        })
      },
      invitedList() {
        let that = this
          that.$http.get('/api/v1/supplier/project/invitedList.json').then(function (res) {
          if (res.code === 200) {
            that.inviteData = res.result
          }
        })
      },
      toAccount() {
        this.$router.push({path: '/account/AccountManage'})
      },
      toIndex() {
        this.$router.push({path: '/Index'})
      },
       onHelp() {
            this.$router.push({path:'/message/SysHelp'})
        },
      toAnnounceIndex() {
        this.$router.push({path: '/announce/AnnounceIndex'})
      },
      inviteDetails(item) {
          if (item.systemType==='1'){
              this.$refs.inviteLegal.initData(item.inviteId)
              this.inviteLegalVisible = true
          }else if (item.systemType==='4'){
              this.$refs.inviteDemand.initData(item.inviteId)
              this.inviteDemandVisible = true
          }
          else{
              this.$refs.invite.initData(item.inviteId)
              this.inviteVisible = true
          }
      },
      inviteCancel() {
         this.inviteVisible = false
      },
      inviteLegalCancel() {
         this.inviteLegalVisible = false
      },
      actCancle() {
        this.accountVisible = false
      },
      showTip() {
        this.accountVisible = true
      },
      opneGuidelines(projectId){
        this.$refs.biddingGuidelines.initModal(projectId)
      }
    }
  }
  ;
</script>
<style lang="less" scoped>
    .handle .right a{
        margin-left: 30px;
    }
    .i-my-info{
        overflow: hidden;width: 100%;height: 225px;position: relative
    }
    .main-nav a{
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px;
        background: rgba(255, 255, 255, 0.3);
        margin-right: 2px;
        height: 76px;
    }
    .main-nav a b{
        color: #fff;
        font-weight: 500;
        margin-left: 10px;
    }
    .main-nav a .icon:nth-child(1){
        display: none;
    }
    .main-nav .active{
        background: #f9f9ff;
    }
    .main-nav .active .icon:nth-child(1){
        display: block;
    }
    .main-nav .active .icon:nth-child(2){
        display:none;
    }
    .main-nav .active b{
        color: inherit;
    }
    .main-nav a:hover{
        background: #f9f9ff;
    }
    .main-nav a:hover b{
        color: inherit;
    }
    .main-nav a:hover .icon:nth-child(1){
        display: block;
    }
    .main-nav a:hover .icon:nth-child(2){
        display:none;
    }
    .icon {
        width: 36px;
        height: 36px;
        vertical-align: -0.15em;
        fill: currentColor;
        overflow: hidden;
        line-height: 30px;
        display: block;
    }

    .index-bg {
        position: absolute;
        width: 1920px;
        left: 50%;
        margin-left: -960px;
    }

    .index-info {
        display: flex;
        align-items: center;
        color: #fff;
    }

    .index-info img {
        display: block;
    }

    .index-info p {
        margin: 0;
    }

    .shadow {
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.2);
        border-radius: 6px;
    }

    .shadow:hover {
        background: #f1f9ff;
    }

    /deep/ .ant-tabs-nav .ant-tabs-tab {
        font-size: 20px;
        font-weight: bold;
    }

    /deep/ .ant-tabs-ink-bar {
        bottom: 1px;
        height: 3px;
    }

    /deep/ .ant-list-item-action li {
        padding: 0 30px;
        display: flex;
        align-items: center;
        cursor: auto;
        min-height: 74px;
    }

    /deep/ .ant-list-item-action-split {
        margin-top: 0;
        height: 100%;
        top: 0;
    }

    /deep/ .ant-list-item-action {
        display: flex;
    }

    /deep/ .ant-list-item-meta-title > a {
        font-size: 20px;
    }

    /deep/ .ant-list-item-extra-wrap {
        width: 100%;
        min-height: 74px;
    }

    /deep/ .ant-list-item-extra {
        margin-top: -30px;
        margin-bottom: 0;
    }

    /deep/ .ant-list-item-extra span {
        margin-right: 40px;
    }

    /deep/ .ant-list-item-meta-title {
        margin-top: 8px;
        color: #262626;
        font-weight: bold;
    }

    /deep/ .ant-list-item-meta-title a:hover {
        color: rgb(24, 144, 255) !important;
    }

    /deep/ .ant-list-item {
        position: relative;
        padding: 20px 0 20px 20px;
        background: #fff;
    }

    /deep/ .ant-tabs-bar {
        margin-bottom: 0;
        border-bottom: 3px solid #e6e6e6;
    }
</style>
